import { createAction } from 'redux-actions';
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const CLEAR_PROMO_CODE = 'CLEAR_PROMO_CODE';
export const setPromoCode = createAction(SET_PROMO_CODE);
export const clearPromoCode = createAction(CLEAR_PROMO_CODE);
